import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../shared/services/session.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthStatusByCodeUtil } from '../../model/util/auth-status-by-code-util';
import { AuthStatus } from '../../model/enum/auth-status.enum';
import { UserService } from 'src/app/shared/services/user.service';
import { CreateShoppingCreditSessionResponse } from "../../model/create.shopping.credit.session";
import { UpdateOrderForCreditProvider } from "../../model/update.order.for.credit.provider";
import DOMPurify from 'dompurify';
import {PaycellErrorDto} from "../../model/paycell.error.dto";

@Component({
  selector: 'pa-route',
  templateUrl: './route.component.html',
  styleUrls: ['./route.component.scss']
})
export class RouteComponent implements OnInit {
  trackingId: string;

  constructor(private sessionService: SessionService, private userService: UserService, private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.trackingId = params.trackingId;
    });
    this.sessionService.getInitUser(this.trackingId).subscribe(user => {
      switch (AuthStatusByCodeUtil.getAuthStatusByCode(user.authStatus)) {
        //BrandIcon olayına tekrar dönüp bakılacak.
        case AuthStatus.WAITING_OTP_VALIDATION: {
          this.router.navigate(['/login/phone-login', this.trackingId]);
          return;
        }
        case AuthStatus.WAITING_OTP_CHECK: {
          this.router.navigate(['/login/otp-entry', this.trackingId]);
          return;
        }
        case AuthStatus.WAITING_PIN_VALIDATION: {
          this.router.navigate(['/login/pin-entry', this.trackingId]);
          return;
        }
        case AuthStatus.WAITING_CREATE_PIN: {
          this.router.navigate(['/login/pin-create', this.trackingId]);
          return;
        }
        case AuthStatus.WAITING_REFRESH_PIN: {
          this.router.navigate(['/login/pin-create', this.trackingId]);
          return;
        }
        case AuthStatus.WAITING_CARD_VALIDATION: {
          this.router.navigate(['/sign-up/card', this.trackingId]);
          return;
        }
        case AuthStatus.WAITING_REGISTRATION: {
          this.router.navigate(['/sign-up/form', this.trackingId]);
          return;
        }
        case (user.loginWebSdk && AuthStatus.AUTHENTICATED): {
          this.userService.createShoppingCreditSession(this.trackingId).subscribe((response: CreateShoppingCreditSessionResponse) => {
          window.location.href = DOMPurify.sanitize(response.creditProviderUrl);
          }, (result) => {

            const errorModel: PaycellErrorDto = result.error;
            this.router.navigate(['/result/error', this.trackingId], {
              queryParams: {message: errorModel.message}
            });
            return;
          });

          return;
        }
        case AuthStatus.AUTHENTICATED: {
          this.router.navigate(['/payment/selection', this.trackingId]);
          return;
        }
        default: {
          this.router.navigate(['/login/phone-login', this.trackingId]);
          return;
        }
      }
    }, error => {
      this.router.navigate(['/result/error', this.trackingId]);
    });
  }

}
